import {Injectable} from "@angular/core";
import {BaseApi} from "./baseService";
import {BaseResponse} from "../objects/common/baseResponse";
import {Order} from "../objects/orders/order";
import { RequestOptions } from "@angular/http";
import { PaymentCompany } from "../objects/payment/paymentCompany";

@Injectable()
export class PaymentService extends BaseApi {


    public save(data: any): Promise<BaseResponse<Object>>{
        return this.post(new RequestOptions({
            url : "payment/save",
            body : data
        }));
    }

    public pay(orderId: string, amount: number, currencyCode: string, customerId: number, agentId: number, agentEmail: string, paymentCompany: PaymentCompany): Promise<BaseResponse<Object>>{
        return this.post(new RequestOptions({
            url : `payment/pay`,
            body: { FileNumber: orderId, amount: amount, CurrencyCode: currencyCode, CustomerId: customerId, AgentId: agentId, AgentEmail: agentEmail, PaymentCompany: paymentCompany}
        }));
    }

}



// WEBPACK FOOTER //
// ./app/services/paymentService.ts